import { api } from "./AxiosInstance";

export const EmpOnboarding = async (payload,isUpdate,id) => {


  if(isUpdate) {
    return await api.patch(`/api/employees/personal-details?_id=${id}`, payload);
    
  }else {
    return await api.post(`/api/employees/personal-details`, payload);
  }

  
  }

export const ContactDetailAPi = async (payload,isUpdate,id) => {

  if(isUpdate) {
    return await api.patch(`/api/employees/contact-details?_id=${id}`, payload);
    
  }else {
    return await api.post(`/api/employees/contact-details`, payload);
  }
}
  

export const AddressDetailAPi = async (payload,isUpdate,id) => {
  if(isUpdate) {
    return await api.patch(`/api/employees/address-details?_id=${id}`, payload);
    
  }else {
   return await api.post(`/api/employees/address-details`, payload);
  }
}
  
  

export const EducationDetailAPi = async (payload,isUpdate,id) =>
   {
  if(isUpdate) {
    return await api.patch(`/api/employees/education-details?_id=${id}`,  { education: payload });
    
  }else {
   return await api.post(`/api/employees/education-details`, { education: payload });
  }
}
  

export const KnowMyTeamAPI = async (payload,isUpdate,id) =>
   {
  if(isUpdate) {
    return await api.patch(`/api/employees/update-know-my-team?_id=${id}`, payload);
    
  }else {
   return await api.post(`/api/employees/know-my-team`, payload);
  }
}
  

export const BankDetailAPI = async (payload,id, isUpdate) => {
  if(isUpdate) {
    return  await api.patch(`/api/employees/bank-details?_id=${id}`, payload);

  }else {
    return  await api.post(`/api/employees/bank-details`, payload);

  }
}
 
export const uploadDocumentsAPI = async (formData,id,isUpdate) => {
  if(isUpdate) {
 return await api.patch(`/api/employees/update-documents?_id=${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  }else {
 return await api.post(`/api/employees/upload-documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  }
 
};

export const SubmitNomineeApi = async (payload) => {
  const formattedPayload = payload.map((item) => ({
    ...item,
    share_percentage: parseInt(item.share_percentage),
  }));

  return await api.post(`/api/employees/nominee-details`, {
    nominees: formattedPayload,
  });
};

export const getEmployeeDetailApi = async (type) =>
  await api.get(`/api/employees/employee-details`);

export const getEmployeeDetailApi2 = async (id) =>
  await api.get(`/api/employees/admin-employee-details?_id=${id}`);
